import { Command } from "commander";
import chalk from "chalk";
import { listStorages } from "../../lib/api";
import { formatBytes, formatRelativeTime } from "../../lib/utils/file-utils";
import { withErrorHandler } from "../../lib/command";

export const listCommand = new Command()
  .name("list")
  .alias("ls")
  .description("List all remote artifacts")
  .action(
    withErrorHandler(async () => {
      // Call API
      const items = await listStorages({ type: "artifact" });

      if (items.length === 0) {
        console.log(chalk.dim("No artifacts found"));
        console.log(
          chalk.dim(
            "  Create one with: vm0 artifact init && vm0 artifact push",
          ),
        );
        return;
      }

      // Calculate column widths
      const nameWidth = Math.max(
        4,
        ...items.map((i) => {
          return i.name.length;
        }),
      );
      const sizeWidth = Math.max(
        4,
        ...items.map((i) => {
          return formatBytes(i.size).length;
        }),
      );
      const filesWidth = Math.max(
        5,
        ...items.map((i) => {
          return i.fileCount.toString().length;
        }),
      );

      // Print header
      const header = [
        "NAME".padEnd(nameWidth),
        "SIZE".padStart(sizeWidth),
        "FILES".padStart(filesWidth),
        "UPDATED",
      ].join("  ");
      console.log(chalk.dim(header));

      // Print rows
      for (const item of items) {
        const row = [
          item.name.padEnd(nameWidth),
          formatBytes(item.size).padStart(sizeWidth),
          item.fileCount.toString().padStart(filesWidth),
          formatRelativeTime(item.updatedAt),
        ].join("  ");
        console.log(row);
      }
    }),
  );
